// Constantes para status de membros
export const MEMBER_STATUS = {
  V: 'Em Verificação',
  A: 'Ativo',
  S: 'Semi-Ausente',
  AU: 'Ausente',
  JA: 'Justificativa de Ausência',
  D: 'Destaque'
} as const;

export const STATUS_COLORS = {
  V: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/40 dark:text-yellow-300',
  A: 'bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-300',
  S: 'bg-orange-100 text-orange-800 dark:bg-orange-900/40 dark:text-orange-300',
  AU: 'bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-300',
  JA: 'bg-purple-100 text-purple-800 dark:bg-purple-900/40 dark:text-purple-300',
  D: 'bg-yellow-100 text-yellow-800 border border-yellow-400 dark:bg-yellow-900/40 dark:text-yellow-300 dark:border-yellow-600'
} as const;

// Mapeamento de categorias para exibição
export const CATEGORIAS_MAP: Record<string, { nome: string; cor: string }> = {
  aula: { nome: 'Aula', cor: '#3B82F6' },
  atividade: { nome: 'Atividade', cor: '#10B981' },
  projeto: { nome: 'Projeto', cor: '#8B5CF6' },
};

export const getCategoriaInfo = (categoria: string) => {
  return CATEGORIAS_MAP[categoria] || { nome: categoria, cor: '#6B7280' };
};
